import React, { useEffect, useState } from "react";
import { Button, Container, Input } from "@amzn/awsui-components-react/polaris";
import { Cards } from "@amzn/awsui-components-react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/rootReducer";
import { fetchUserInfo } from "../userInfo/userInfoSlice";
import { SUBMISSION_CARD_DEFINITION } from "./oneClickLaunchSubmissionTools-config";
import { fetchLaunchWorkflowsByRequester } from "./oneClickLaunchSubmissionToolsConnector";
import { trackButtonClick } from "../telemetry/telemetry";

export const OclSubmissionTools = () => {
  const dispatch = useDispatch();
  const { userName, isLoading } = useSelector(
    (state: RootState) => state.userInfo
  );
  const { isGettingLaunchWorkflowsForUser, items } = useSelector(
    (state: RootState) => state.oneClickLaunchSubmissionToolsControl
  );

  const [searchedUserName, setSearchedUserName] = useState(userName);
  const [cardItems, setCardItems] = useState(items);

  useEffect(() => {
    dispatch(fetchUserInfo());
  }, []);

  useEffect(() => {
    setSearchedUserName(userName);
    dispatch(
      fetchLaunchWorkflowsByRequester({
        from: 0,
        pageSize: 50,
        requester: {
          identity: searchedUserName,
          type: "principal",
        },
      })
    );
  }, [userName]);

  useEffect(() => {
    setCardItems(items);
  }, [items]);

  return (
    <Container
      header={
        <>
          <h2>Submission History</h2>
          {/*TODO: Uncomment this when we want to add pagination*/}
          {/*<div style={{ display: "flex", justifyContent: "right" }}>*/}
          {/*  <Pagination*/}
          {/*    currentPageIndex={0}*/}
          {/*    openEnd={true}*/}
          {/*    pagesCount={0}*/}
          {/*    onNextPageClick={(event) => {*/}
          {/*      // TODO: api call for next page of submissions.*/}
          {/*    }}*/}
          {/*    onPreviousPageClick={(event) => {*/}
          {/*      // TODO: api call for previous page of submissions.*/}
          {/*    }}*/}
          {/*  />*/}
          {/*</div>*/}
        </>
      }
    >
      Requested by
      <Input
        value={searchedUserName}
        placeholder={"alias"}
        disabled={isLoading}
        onChange={(e) => {
          setSearchedUserName(e.detail.value);
        }}
      />
      <p />
      <div style={{ display: "flex", justifyContent: "right" }}>
        <Button
          variant={"primary"}
          children={"Search"}
          iconName={"search"}
          iconAlign={"right"}
          onClick={() => {
            trackButtonClick("oneClickLaunchTable", "Search", {
              userName: searchedUserName,
            });
            dispatch(
              fetchLaunchWorkflowsByRequester({
                from: 0,
                pageSize: 50,
                requester: {
                  identity: searchedUserName,
                  type: "principal",
                },
              })
            );
          }}
        />
      </div>
      <br />
      <Cards
        items={cardItems}
        cardDefinition={SUBMISSION_CARD_DEFINITION}
        loading={isGettingLaunchWorkflowsForUser}
      />
    </Container>
  );
};
